import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBrandsList } from "../../Redux/Actions/brandsActions";

const BrandsNearbySelector = ({ selected = [], onChange }) => {
    const dispatch = useDispatch();
    const [search, setSearch] = useState("");
    const [popup, setPopup] = useState(false);
    const { brands } = useSelector((state) => state.brands || {});
    const brandsList = Array.isArray(brands?.data) ? brands.data : [];

    useEffect(() => {
        dispatch(getBrandsList({ page: 1, limit: 500, filter: "" }));
    }, [dispatch]);

    const filtered = brandsList.filter((b) =>
        b.name?.toLowerCase().includes(search.toLowerCase())
    );

    const toggleBrand = (brand) => {
        const getId = (b) => b._id || b.id || b.brand_id || b.name; // fallback to name
        const brandId = getId(brand);

        const alreadySelected = selected.some((s) => getId(s) === brandId);
        const updated = alreadySelected
            ? selected.filter((s) => getId(s) !== brandId)  // ✅ remove only exact match
            : [...selected, { _id: brand._id, name: brand.name, image: brand.image || "" }];
        onChange(updated);
    };

    const isSelected = (brand) => selected.some((s) => s._id === brand._id);

    return (
        <div>
            {/* Trigger */}
            <div
                className="acp-input"
                style={{
                    minHeight: 44,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                }}
                onClick={() => setPopup(true)}
            >
                <span style={{ color: selected.length ? "#111827" : "#9ca3af" }}>
                    {selected.length > 0 ? `${selected.length} brand(s) selected` : "Select brands nearby"}
                </span>
                <span style={{ fontSize: 18, color: "#9ca3af" }}>+</span>
            </div>

            {/* Selected Tags */}
            {selected.length > 0 && (
                <div className="acp-tags-row" style={{ marginTop: 10 }}>
                    {selected.map((brand) => (
                        <span key={brand._id} className="acp-tag">
                            {brand.image && (
                                <img
                                    src={brand.image}
                                    alt={brand.name}
                                    style={{ width: 16, height: 16, borderRadius: 3, objectFit: "cover" }}
                                />
                            )}
                            {brand.name}
                            <button
                                type="button"
                                className="acp-tag-remove"
                                onClick={() => toggleBrand(brand)}
                            >×</button>
                        </span>
                    ))}
                </div>
            )}

            {/* Popup */}
            {popup && (
                <div style={{
                    position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
                    background: "rgba(0,0,0,0.4)", zIndex: 1000,
                    display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                    <div style={{
                        background: "#fff", borderRadius: 16, padding: 24,
                        width: "90%", maxWidth: 560,
                        maxHeight: "80vh", display: "flex", flexDirection: "column", gap: 12,
                    }}>
                        {/* Header */}
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>
                                Select Brands Nearby
                                {selected.length > 0 && (
                                    <span style={{
                                        marginLeft: 8, fontSize: 11, fontWeight: 500,
                                        background: "#0D152B", color: "#fff",
                                        padding: "2px 8px", borderRadius: 20,
                                    }}>{selected.length}</span>
                                )}
                            </h3>
                            <button
                                type="button"
                                className="acp-btn acp-btn--cancel"
                                style={{ padding: "6px 16px", fontSize: 13 }}
                                onClick={() => setPopup(false)}
                            >Done</button>
                        </div>

                        {/* Search */}
                        <input
                            className="acp-input"
                            type="text"
                            placeholder="Search brands..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />

                        {/* Brand List */}
                        <div style={{ overflowY: "auto", display: "flex", flexDirection: "column", gap: 8 }}>
                            {filtered.length === 0 ? (
                                <p style={{ textAlign: "center", color: "#9ca3af", padding: "20px 0", fontSize: 14 }}>
                                    No brands found.
                                </p>
                            ) : (
                                filtered.map((brand) => {
                                    const active = isSelected(brand);
                                    return (
                                        <div
                                            key={brand._id}
                                            onClick={() => toggleBrand(brand)}
                                            style={{
                                                display: "flex", alignItems: "center", gap: 12,
                                                padding: "10px 14px", borderRadius: 10, cursor: "pointer",
                                                border: active ? "2px solid #0D152B" : "1px solid #e5e7eb",
                                                background: active ? "#eceef2" : "#fafafa",
                                                transition: "all 0.15s ease",
                                            }}
                                        >
                                            {/* Checkbox */}
                                            <div style={{
                                                width: 20, height: 20, borderRadius: 5, flexShrink: 0,
                                                border: active ? "2px solid #0D152B" : "2px solid #d1d5db",
                                                background: active ? "#0D152B" : "white",
                                                display: "flex", alignItems: "center", justifyContent: "center",
                                            }}>
                                                {active && (
                                                    <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                                                        <polyline points="1.5 6 4.5 9 10.5 3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                )}
                                            </div>

                                            {/* Brand Image */}
                                            {brand.image ? (
                                                <img
                                                    src={brand.image}
                                                    alt={brand.name}
                                                    style={{ width: 36, height: 36, borderRadius: 8, objectFit: "cover", flexShrink: 0, border: "1px solid #e5e7eb" }}
                                                />
                                            ) : (
                                                <div style={{
                                                    width: 36, height: 36, borderRadius: 8, flexShrink: 0,
                                                    background: active ? "#d8dce6" : "#f3f4f6",
                                                    display: "flex", alignItems: "center", justifyContent: "center",
                                                    fontSize: 15, fontWeight: 600, color: active ? "#0D152B" : "#9ca3af",
                                                }}>
                                                    {brand.name?.[0]?.toUpperCase() || "B"}
                                                </div>
                                            )}

                                            {/* Brand Name */}
                                            <span style={{
                                                fontSize: 14, fontWeight: active ? 600 : 400,
                                                color: active ? "#0D152B" : "#374151",
                                            }}>{brand.name}</span>
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BrandsNearbySelector;